import React from 'react'
import { Button, ButtonGroup, Dropdown, SplitButton } from 'react-bootstrap'
import OnHoverTooltip from "../../../../components/tables/shared/OnHoverTooltip"
import PrimaryActionButton from './course-primary-action-button';
import { bookingStatusOptions, translateOptionValue, getOptionsObjectValue } from '../../../../components/exl/shared/translations';
import ExlMailCalendarIcons from '../../../../components/exl/icons/ExlMailCalendarIcons';
import { useTranslation } from 'react-i18next';
import {
    COURSE_DETAILS_HEADER_ADD_LECTURE_LABEL,
    COURSE_DETAILS_HEADER_DUPLICATE_COURSE_LABEL,
    COURSE_DETAILS_HEADER_EDIT_BOOKINGS_LABEL,
    COURSE_DETAILS_HEADER_EDIT_COURSE_LABEL,
    COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_LABEL,
    COURSE_DETAILS_HEADER_EMAIL_RESERVE_BOOKINGS_LABEL,
    EMAIL_NOTIFICATIONS_FALSE,
    EMAIL_NOTIFICATIONS_TRUE,
    COURSE_DETAILS_HEADER_DELETE_COURSE_LABEL,
    COURSE_DETAILS_HEADER_YOUR_STATUS,
    COURSE_DETAILS_HEADER_CREATE_LECTURE_TOOLTIP
} from '../../../../i18n/keyConstants';
import { getIcon } from '../../../../components/crm/shared/field_inputs/shared/FormatHelpers';

const CourseActions = ({
    course,
    courseUser,
    refreshCourseData,
    setEditCourseModalOpen,
    setDuplicateCourseModalOpen,
    setDeleteCourseModalOpen,
    setAddLectureModalOpen,
    setEditBookingsModalOpen,
    setEmailConfirmedBookingsModalOpen,
    setEmailReserveBookingsModalOpen,
    confirmedParticipants,
    reserveParticipants
}) => {
    const { t } = useTranslation(['courseDetailsHeader', 'shared']);
    console.log(confirmedParticipants)
    return (
        <div className='flex-wrap course-actions' style={{ display: "flex", gap: "8px" }}>

            {courseUser.booking && (
                <div className={"d-flex card align-items-center user-status flex-row p-1"} style={{ justifyContent: 'space-between' }}>
                    <div className='user-icon' style={{ color: "grey", paddingRight: 3 }}> {getIcon("person")} </div>
                    <p style={{ color: "grey", margin: 0, paddingRight: 4, fontWeight: 'bolder' }}> {t(COURSE_DETAILS_HEADER_YOUR_STATUS)} </p>
                    <p style={{ color: "black", margin: 0, paddingRight: 3 }}> {t(translateOptionValue(courseUser.booking.status, bookingStatusOptions), { ns: 'shared' })}</p>
                </div>
            )}

            {(courseUser.editPermission || courseUser.teacherPermission) && (
                <div style={{ display: "flex", display: 'inline-block' }}>
                    <ExlMailCalendarIcons
                        sendEmailNotifications={course.sendEmailNotifications}
                        trueText={t(EMAIL_NOTIFICATIONS_TRUE, { ns: "shared" })}
                        falseText={t(EMAIL_NOTIFICATIONS_FALSE, { ns: "shared" })}
                        tooltipPlace='left'
                        t={t}
                    />
                </div>
            )}

            <PrimaryActionButton
                course={course}
                courseUser={courseUser}
                refreshCourseData={refreshCourseData}
            />

            {(courseUser.editPermission || courseUser.teacherPermission) && (
                <Dropdown as={ButtonGroup} className="exl-button-group exl-course-edit-dropdown" >
                    <Button variant="info" onClick={() => setEditCourseModalOpen(true)} className="exl-button">{t(COURSE_DETAILS_HEADER_EDIT_COURSE_LABEL)}</Button>

                    {courseUser.editPermission && (
                        <>
                            <Dropdown.Toggle split variant="info" id="dropdown-split-basic" className='exl-button' />
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    eventKey="1"
                                    onClick={() => setAddLectureModalOpen(true)}
                                >
                                    {t(COURSE_DETAILS_HEADER_ADD_LECTURE_LABEL)}
                                </Dropdown.Item>
                                {course.lectures < 1 ? //prevents editing of bookings if no lectures are created to avoid bookings with no dates
                                    <OnHoverTooltip
                                        labelClassNames='d-flex margin-none'
                                        tooltipType='dark'
                                        tooltipPlace='left'
                                        tooltipEffect='solid'
                                    >
                                        <Dropdown.Item
                                            eventKey="2"
                                            onClick={() => setEditBookingsModalOpen(true)}
                                            disabled={course.lectures < 1 ? true : false}
                                            className={course.lectures < 1 ? "text-muted" : ""}>
                                            {t(COURSE_DETAILS_HEADER_EDIT_BOOKINGS_LABEL)}
                                        </Dropdown.Item>
                                        <span className='d-flex my-auto' style={{ width: 125 }}>{t(COURSE_DETAILS_HEADER_CREATE_LECTURE_TOOLTIP)}</span>
                                    </OnHoverTooltip>
                                    :
                                    <Dropdown.Item
                                        eventKey="2"
                                        onClick={() => setEditBookingsModalOpen(true)}>
                                        {t(COURSE_DETAILS_HEADER_EDIT_BOOKINGS_LABEL)}
                                    </Dropdown.Item>
                                }
                                <Dropdown.Item
                                    eventKey="3"
                                    onClick={() => setDuplicateCourseModalOpen(true)}
                                >
                                    {t(COURSE_DETAILS_HEADER_DUPLICATE_COURSE_LABEL)}
                                </Dropdown.Item>
                                {confirmedParticipants.length > 0 &&
                                    <Dropdown.Item

                                        eventKey="4"
                                        onClick={() => setEmailConfirmedBookingsModalOpen(true)}
                                    >
                                        {t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_LABEL)}
                                    </Dropdown.Item>
                                }
                                {reserveParticipants.length > 0 &&

                                    <Dropdown.Item
                                        eventKey="4"
                                        onClick={() => setEmailReserveBookingsModalOpen(true)}
                                    >
                                        {t(COURSE_DETAILS_HEADER_EMAIL_RESERVE_BOOKINGS_LABEL)}
                                    </Dropdown.Item>
                                }
                                <Dropdown.Item
                                    eventKey="5"
                                    onClick={() => setDeleteCourseModalOpen(true)}
                                >
                                    {t(COURSE_DETAILS_HEADER_DELETE_COURSE_LABEL)}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </>
                    )}
                    {(courseUser.teacherPermission && !courseUser.editPermission) && (
                        <>
                            <Dropdown.Toggle split variant="info" id="dropdown-split-basic" />
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    eventKey="1"
                                    onClick={() => setEmailConfirmedBookingsModalOpen(true)}
                                >
                                    {t(COURSE_DETAILS_HEADER_EMAIL_CONFIRMED_BOOKINGS_LABEL)}
                                </Dropdown.Item>
                                <Dropdown.Item
                                    eventKey="1"
                                    onClick={() => setEmailReserveBookingsModalOpen(true)}
                                >
                                    {t(COURSE_DETAILS_HEADER_EMAIL_RESERVE_BOOKINGS_LABEL)}
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </>
                    )}
                </Dropdown>
            )}


        </div>
    )
}

export default function CourseDetailsHeader({
    course,
    courseUser,
    refreshCourseData,
    setEditCourseModalOpen,
    setDuplicateCourseModalOpen,
    setDeleteCourseModalOpen,
    setAddLectureModalOpen,
    setEmailConfirmedBookingsModalOpen,
    setEmailReserveBookingsModalOpen,
    setEditBookingsModalOpen,
    confirmedParticipants,
    reserveParticipants
}) {
    return (
        <div
            className='exl-course-details-header'
            style={{
                position: "sticky",
                top: 0,
                paddingTop: 24,
                paddingBottom: 24,
                background: "#f5f5f5",
                zIndex: 2,
            }}>

            <div className='exl-course-details-header-name'>
                <h1 style={{ margin: 0, textAlign: "center" }}>{course.name}</h1>
            </div>

            <CourseActions
                course={course}
                courseUser={courseUser}
                refreshCourseData={refreshCourseData}
                setEditCourseModalOpen={setEditCourseModalOpen}
                setDuplicateCourseModalOpen={setDuplicateCourseModalOpen}
                setDeleteCourseModalOpen={setDeleteCourseModalOpen}
                setAddLectureModalOpen={setAddLectureModalOpen}
                setEditBookingsModalOpen={setEditBookingsModalOpen}
                setEmailConfirmedBookingsModalOpen={setEmailConfirmedBookingsModalOpen}
                setEmailReserveBookingsModalOpen={setEmailReserveBookingsModalOpen}
                confirmedParticipants={confirmedParticipants}
                reserveParticipants={reserveParticipants}
            />
        </div>
    )
}
